import { ChangeDetectorRef } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { catchError, map, Observable, of, take, tap } from 'rxjs';
import { TemplateLibraryRepository } from '../services/template-library.repository';

export class UniqueTemplateNameValidator {
  static createValidator(
    templateLibraryRepository: TemplateLibraryRepository,
    cdr: ChangeDetectorRef
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value || control.pristine) return of(null);

      return templateLibraryRepository.getTemplateByName(control.value).pipe(
        map(templateExists => (templateExists ? { notUnique: true } : null)),
        catchError(_ => of(null)),
        tap(() => cdr.markForCheck()),
        take(1)
      );
    };
  }
}

export const invalidSymbolsValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const containsInvalidSymbols = /^\s|\s$/.test(control.value);
    return containsInvalidSymbols ? { invalidSymbols: true } : null;
  };
};
